<script>
  import { formatTimeLabel } from '$lib/utils/datetime';

  export let fromMe = false;
  export let sameSender = false;
  export let time = '';

  $: label = fromMe ? '🚫 Bạn đã thu hồi tin nhắn' : '🚫 Tin nhắn đã được thu hồi';
</script>

<div class:recalled-row--me={fromMe} class="recalled-row">
  <!-- svelte-ignore a11y_no_static_element_interactions -->
  <div
    class:recalled-bubble--me={fromMe}
    class:recalled-bubble--other={!fromMe}
    class:recalled-bubble--same-sender={sameSender}
    class="recalled-bubble"
    on:contextmenu={(event) => event.preventDefault()}>
    <p>{label}</p>

    <time datetime={time} class="recalled-time">
      {formatTimeLabel(time)}
    </time>
  </div>
</div>

<style>
  .recalled-row {
    display: flex;
    justify-content: flex-start;
    width: 100%;
    user-select: text;
  }

  .recalled-row--me {
    justify-content: flex-end;
  }

  .recalled-bubble {
    position: relative;
    max-width: 68%;
    margin-top: 0.5rem;
    padding: 0.75rem 1rem 1rem;
    border: 1px dashed #d1d5db;
    border-radius: 1rem;
    color: #9ca3af;
    background: #f9fafb;
    font-size: 0.875rem;
    font-style: italic;
  }

  .recalled-bubble--same-sender {
    margin-top: 0.125rem;
  }

  .recalled-bubble--me {
    border-bottom-right-radius: 0.375rem;
  }

  .recalled-bubble--other {
    border-bottom-left-radius: 0.375rem;
  }

  p {
    margin: 0;
    line-height: 1.375;
    white-space: pre-line;
  }

  .recalled-time {
    position: absolute;
    right: 0.5rem;
    bottom: 0.25rem;
    font-size: 0.5625rem;
    line-height: 1;
    opacity: 0.6;
  }
</style>
